import { render, staticRenderFns } from "./VOrderRefundOrder.vue?vue&type=template&id=0bcb8d5c&scoped=true"
import script from "./VOrderRefundOrder.vue?vue&type=script&lang=ts"
export * from "./VOrderRefundOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb8d5c",
  null
  
)

export default component.exports